
const plans = document.querySelectorAll('input[name="plans"]');

plans.forEach(function(plan) {
    plan.addEventListener('change', function() {
        const singlePrice = plan.getAttribute('data-price-single');
        const familyPrice = plan.getAttribute('data-price-family');
        //const period = plan.getAttribute('data-period');
        const incident = plan.getAttribute('data-incident');


        document.getElementById('singlePrice').textContent = singlePrice;
        document.getElementById('familyPrice').textContent = familyPrice;
        /* document.querySelectorAll('.c-choose__period').forEach(item => {
            item.textContent = period;
        }); */
        document.querySelectorAll('.c-choose__incident').forEach(item => {
            item.textContent = incident;
        });
    });
});
// Capturando los data-plan-type de btn submit antes de enviar el form
document.querySelectorAll('.js-choose__submit').forEach(button => {
  button.onclick = function(event) {
    event.preventDefault();

    const hiddenInput = document.querySelector('#inputHiddenChoose');
    hiddenInput.value = this.dataset.planType;

    document.getElementById('js-choose-form').submit();
  };
});